import styled from "@emotion/styled";

export default styled.section`
  margin: 2rem auto 9rem;
  padding: 1.4rem 1rem;
  max-width: 910px;
`;
